import type { DrawingElement } from 'features/Procedure/state/procedure.type'
import { DrawingElementVisibleState } from 'features/Procedure/state/procedure.type'

export const getUndoableElements = (drawingElements: DrawingElement[]): DrawingElement[] =>
  drawingElements.filter(
    (el) =>
      el.visibleState === DrawingElementVisibleState.VISIBLE ||
      el.visibleState === DrawingElementVisibleState.HIDDEN,
  )

export const getVisibleDrawingElements = (drawingElements: DrawingElement[]): DrawingElement[] =>
  drawingElements.filter(
    (el) =>
      el.visibleState === DrawingElementVisibleState.VISIBLE ||
      el.visibleState === DrawingElementVisibleState.PERSISTED,
  )

export const getProcedureDrawingElements = (
  drawingElements: DrawingElement[],
  procedureId: number | null | undefined,
): DrawingElement[] => {
  if (procedureId == null) return []

  return drawingElements.filter((el) => el.procedureId === procedureId)
}

export const getSortedUndoableElements = (drawingElements: DrawingElement[]): DrawingElement[] =>
  getUndoableElements(drawingElements).sort((a, b) => a.timestamp - b.timestamp)

export const getLastVisibleUndoable = (
  drawingElements: DrawingElement[],
): DrawingElement | undefined => {
  const sortedUndoableElements = getSortedUndoableElements(drawingElements)
  return sortedUndoableElements
    .filter((el) => el.visibleState === DrawingElementVisibleState.VISIBLE)
    .slice(-1)[0]
}

export const filterElementsForNewAddition = (
  drawingElements: DrawingElement[],
  lastVisibleUndoable?: DrawingElement,
): DrawingElement[] => {
  if (!lastVisibleUndoable) return drawingElements

  return drawingElements.filter((el) => {
    const isVisible = [
      DrawingElementVisibleState.PERSISTED,
      DrawingElementVisibleState.VISIBLE,
    ].includes(el.visibleState)
    return isVisible && el.timestamp <= lastVisibleUndoable.timestamp
  })
}

export const sortElementsByTimestamp = (elements: DrawingElement[]): DrawingElement[] =>
  [...elements].sort((a, b) => a.timestamp - b.timestamp)
